/// <reference path="services/role-guard.service.ts" />
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { CustomFormsModule } from 'ngx-custom-validators';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './components/home/home.component';
import { MdnusersListComponent } from './components/mdnusers-list/mdnusers-list.component';
import { ClientsListComponent } from './components/clients-list/clients-list.component';
import { ClientComponent } from './components/client/client.component';
import { LeadGridComponent } from './components/lead-grid/lead-grid.component';
import { AuthService } from './services/auth.service';
import { LoginComponent } from './components/login/login.component';
import { AuthInterceptor } from './services/auth.interceptor.service'
import { AuthResponseInterceptor} from './services/auth.response.interceptor.service';
import { RegisterComponent } from './components/register/register.component'
import { AuthGuardService as AuthGuard } from './services/auth.guard.service'
import { RoleGuardService} from './services/role-guard.service';
import { ShowUserComponent } from './components/show-user/show-user.component'
import { UserService } from './services/user.service'
import { Globals } from './services/globals.service'
import { LeadService } from './services/lead.service';
import { PhonePipe } from './pipes/phone.pipe';
import { AddEditLeadComponent } from './components/add-edit-lead/add-edit-lead.component'
import { USStateService } from './services/ng-2-us-states/us-states.service';
import { DropdownService } from './services/dropdown.service';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    MdnusersListComponent,
    ClientsListComponent,
    ClientComponent,
    LeadGridComponent,
    LoginComponent,
    RegisterComponent,
    ShowUserComponent,
    PhonePipe,
    AddEditLeadComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TableModule,
    DialogModule,
    ToastModule,
    ScrollPanelModule,
    PanelModule,
    TabViewModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    InputTextareaModule,
    ButtonModule,
    CheckboxModule,
    CustomFormsModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [RoleGuardService],
        data: {
          expectedRole: 'Administrator'
        }
      },
      {
        path: 'show-user',
        component: ShowUserComponent,
        canActivate: [RoleGuardService],
        data: {
          expectedRole: 'Administrator'
        }
      },
      {
        path: 'register',
        component: RegisterComponent,
        canActivate: [RoleGuardService],
        data: {
          expectedRole: 'Administrator'
        }
      },
      { path: 'lead-grid', component: LeadGridComponent },
      { path: 'add-edit-lead/:lid', component: AddEditLeadComponent },
      { path: 'login', component: LoginComponent }
    ])
  ],
  providers: [MessageService,
    AuthService,
    AuthGuard,
    UserService,
    Globals,
    LeadService,
    RoleGuardService,
    USStateService,
    DropdownService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthResponseInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule 
{
  constructor(private auth: AuthService) {
    auth.setAuth(null);
  }

}
